import { useSearchParams } from 'react-router-dom';
import { useMonitoringGoods } from './MonitoringContext';
import { ChartContainer } from '@/components/atoms/Chart';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { MOCK_GOODS } from './_mock/mockGoods';

const WEEKDAY_KO = ['일', '월', '화', '수', '목', '금', '토'];
function formatDateWithDay(dateStr: string) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const weekday = WEEKDAY_KO[date.getDay()];
  return `${month}.${day}(${weekday})`;
}

const GoodsDetaiiPriceChart = () => {
  const [searchParams] = useSearchParams();
  const goodsNo = searchParams.get('select');
  const { goods } = useMonitoringGoods();
  const selectedGoods =
    goods.find((item) => String(item.GoodsNo) === String(goodsNo)) ||
    MOCK_GOODS.find((item) => String(item.GoodsNo) === String(goodsNo));

  // 데이터 준비: Figma와 동일하게 최신 날짜를 왼쪽부터 표시
  const dailyList = selectedGoods?.MonitoringGoodsDetailDailyList?.slice(0, 9) || [];

  // 차트 데이터
  const chartData = dailyList.map((day) => ({
    date: day.MonitoringDate,
    price: day.MonitoringGoodsPrice,
  }));

  if (chartData.length === 0) {
    return null;
  }

  return (
    <div className="mx-[60px] grid h-[360px] gap-y-[16px] rounded-[16px] bg-white p-[20px]">
      <div className="scrollbar flex max-w-full flex-col overflow-x-auto">
        <div className="text-gr-900 Body1S16">가격 변동 추적</div>
        <ChartContainer config={{}} className="h-[294px] min-w-[900px]">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={chartData} margin={{ top: 28, right: 20, bottom: 0, left: 0 }}>
              <XAxis
                dataKey="date"
                tickLine={false}
                axisLine={false}
                tickMargin={10}
                interval={0}
                tick={{
                  fontSize: 14,
                  fontWeight: 500,
                  fill: '#53555E',
                  textAnchor: 'middle',
                }}
                tickFormatter={formatDateWithDay}
              />
              <YAxis
                dataKey="price"
                type="number"
                domain={[0, 40000]}
                ticks={[0, 10000, 20000, 30000, 40000]}
                width={60}
                allowDecimals={false}
                tickFormatter={(value) => Number(value).toLocaleString()}
                tick={{
                  fontSize: 14,
                  fontWeight: 500,
                  fill: '#53555E',
                }}
              />
              <Tooltip
                formatter={(value) => `${value?.toLocaleString()}원`}
                // labelFormatter={(label) => ` ${label}`}
                contentStyle={{ background: 'rgba(255,255,255,0.95)', borderRadius: 8 }}
              />
              <defs>
                <linearGradient id="fillPrice" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#4181FF" stopOpacity={0.16} />
                  <stop offset="95%" stopColor="#4181FF" stopOpacity={0.02} />
                </linearGradient>
              </defs>
              <Area
                dataKey="price"
                type="monotone"
                fill="url(#fillPrice)"
                fillOpacity={0.4}
                stroke="#4181FF"
                strokeWidth={2}
                dot={{ stroke: '#4181FF', strokeWidth: 2, r: 3, fill: '#fff' }}
                isAnimationActive={true}
              />
            </AreaChart>
          </ResponsiveContainer>
        </ChartContainer>
      </div>
    </div>
  );
};

export default GoodsDetaiiPriceChart;
